import numeral from 'numeral'

function getCurrencySymbol (currency) {
  switch (currency.toUpperCase()) {
    case 'USD':
      return '$'
    case 'EURO':
      return '€'
    case 'POUND':
      return '£'
    default:
      return '$'
  }
}

function toCurrency (value, currency) {
  if (!value) return ''
  const currencySymbol = getCurrencySymbol(currency || '')
  return `${currencySymbol}${numeral(parseFloat(value)).format('0.[0]a')}`
}

export {
  toCurrency, getCurrencySymbol
}



// WEBPACK FOOTER //
// ./src/helpers/currency-helper.js